<script>
import FlickerTrend from './FlickerTrend/FlickerTrend.vue'
import PowerTrend from './PowerTrend/PowerTrend.vue'
import RmsVTrend from './RmsTrend/RmsVTrend.vue'
import RmsITrend from './RmsTrend/RmsITrend.vue'
export default {
  name: 'Trend',
  components: {
    FlickerTrend,
    PowerTrend,
    RmsVTrend,
    RmsITrend
  },
  data () {
    return {
      commandInterval: null
    }
  },
  mounted () {
  },
  destroyed () {
    if (this.commandInterval) {
      clearInterval(this.commandInterval)
      this.commandInterval = null
    }

    // 关闭快速模式
    if (this.commandInterval) {
      clearInterval(this.commandInterval)
      this.commandInterval = null
    }
    this.$store.commit('updateSpeedMode', '普通模式')
  },
  methods: {
  }
}
</script>

<template>
  <div class="page">
    <div class="dataBorder">
      <FlickerTrend></FlickerTrend>
      <PowerTrend></PowerTrend>
      <RmsVTrend></RmsVTrend>
    </div>
  </div>
</template>

<style scoped>
.page {
  width: 100%;
  height: 100%;
}

.dataBorder {
  margin: 10px;
  width: calc(100% - 20px);
  height: calc(90vh - 135px);
//overflow: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Trend/Trend.vue